import axios from "axios";
import { Dispatch } from "redux";
import baseUrl from "../../../ApiConfig";
import { setupInterceptorsTo } from "../../Authentication/Interceptors";
import {
  GetSexualOrientationListActionTypes,
  GET_SEXUAL_ORIENTATION_LIST_FAIL,
  GET_SEXUAL_ORIENTATION_LIST_LOADING,
  GET_SEXUAL_ORIENTATION_LIST_SUCCESS,
} from "./ActionTypes";
import { GetSexualOrientationListRes } from "./Model";
import { headers } from "../../../component/Utility";

export const getSexualOrientationList = () => {
  return function (dispatch: Dispatch<GetSexualOrientationListActionTypes>) {
    dispatch({
      type: GET_SEXUAL_ORIENTATION_LIST_LOADING,
    });
    setupInterceptorsTo(axios)
      .get(
        baseUrl.baseUrl + `/patientapp/api/patient/sexualOrientation_dropdown`,
        { headers: headers }
      )
      .then((res) => {
        dispatch({
          type: GET_SEXUAL_ORIENTATION_LIST_SUCCESS,
          payload: res.data,
          errRes: "",
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_SEXUAL_ORIENTATION_LIST_FAIL,
          payload: {} as GetSexualOrientationListRes,
          errRes: error.response.data.message,
        });
      });
  };
};
